import {AccountEmail} from '@core/bo/account-email.model';
import {Organization} from '@core/bo/organization.model';
import {AccountStatus} from '@core/bo/account-status.model';
import {Location} from '@core/bo/location.model';

export class Authority {
    role: string;
    title: string;

    constructor(role?: string) {
        this.role = role;
    }
}

export class AccountBase {
    static STATUS_ACTIVE = [1, 4, 8];
    static STATUS_INACTIVE = [2];
    /*static STATUS_MAP = {
        1: AccountBase.STATUS_ACTIVE,
        2: AccountBase.STATUS_INACTIVE
    }
    static LEVEL_1 = ObjectCategory.newInstance('Nhân viên', 1, null, null);
    static LEVEL_2 = ObjectCategory.newInstance('Mentor', 2, null, null);
    static LEVEL_3 = ObjectCategory.newInstance('Team Leader', 3, null, null);
    static LEVEL_4 = ObjectCategory.newInstance('Giám đốc', 4, null, null);
    static LEVEL_5 = ObjectCategory.newInstance('Chủ tịch', 5, null, null);
    static LEVEL_MAP = {
        1: AccountBase.LEVEL_1,
        2: AccountBase.LEVEL_2,
        3: AccountBase.LEVEL_3,
        4: AccountBase.LEVEL_4,
        5: AccountBase.LEVEL_5
    }*/
    id: number;
    orgId: number;
    password: string;
    passwordSet: string;
    authorities: Authority[];
    emailPersonal: string;
    username: string;
    firstname: string;
    lastname: string;
    fullname: string;
    placeOfBirth: string;
    placeOfResidence: string;
    ethnic: string;
    religion: string;
    profilePath: string;
    identityCode: string;
    identityPhoto1: string;
    identityPhoto2: string;
    identityIssuer: string;
    identityDate: Date;
    taxPersonal: string;
    bankCode: string;
    bankNumber: string;
    birthday: Date;
    birthdayOfYear: string;
    gender: number;
    mobile: string;
    email: string;
    status: number;
    statusEndDate: Date;
    isTrash: boolean;
    isUpdated: boolean;
    code: number;
    oldCode: string;
    hiringDate: Date;
    suspendedDate: Date;
    level: number;
    countryMobileId: number;
    countryId: number;
    leaderId: number;
    profession: number;
    isSocialInsurance: boolean;
    socialInsuranceOrg: string;
    socialInsuranceCode: string;
    socialInsuranceLevel: number;
    title: string;
    orgIdList: number[];
    orgIdGrantList: number[];
    createdBy: number;
    createdDate: Date;
    modifiedBy: number;
    modifiedDate: Date;
    locationId: number;
    employeeType: string;
    workhour: string;
    workday: string;
}

export class Account extends AccountBase {
    static AUTHORITY_MAP = {
        USER: 'Người dùng cơ bản',
        USER_ALL: 'Kiểm tra trùng lặp',
        ACCOUNT: 'Quản lý người dùng',
        ACCOUNT_ID: 'Cập nhật định danh',
        ORGANIZATION: 'Quản lý đơn vị',
        APPROVE: 'Đồng bộ thay đổi',
        ASSIGN_ROLE: 'Gán quyền người dùng',
        CHECK_INOUT_ADMIN: 'Check In/Out Admin',
        CHECK_INOUT: 'Check In/Out',
        CODE2FA: 'Lấy mã xác minh',
        ROOT: 'Quyền tối cao'
    };
    /**
     * "Đối tác" = đơn vị id 92 nằm ngay dưới root. KHÁI NIỆM NÀY ĐÃ CHẾT Ở BACKEND:
     * cột IS_PARTNER và hằng PARTNER_CODE đều đã bị bỏ, backend không còn phân biệt.
     * Đây là nơi DUY NHẤT nó còn sống.
     *
     * Giữ tạm theo quyết định của chủ dự án, với giao kèo: KHÔNG để đơn vị nào có
     * id 92 nằm ngay dưới root, nên isPartner luôn false trên thực tế.
     *
     * ⚠️ NẾU GIAO KÈO ĐÓ VỠ thì nhánh này tự bật lại mà không báo gì, và hậu quả
     * là im lặng chứ không phải lỗi:
     *   - ẩn ba mục của biểu mẫu: Dân tộc, Tham gia BHXH, Khối
     *   - BỎ Validators.required của employeeType, workhour, workday
     * Backend để ba cột đó nullable và không kiểm gì, nên required ở đây là cổng
     * chặn DUY NHẤT — mất nó là dữ liệu vào thiếu mà không ai biết.
     *
     * ID là auto-increment, nên đơn vị thứ 92 được tạo hoàn toàn có thể rơi đúng
     * vào dưới root. Đây là chuyện của may rủi, không phải của thiết kế.
     *
     * Muốn giữ việc nới lỏng đó như một quy tắc THẬT thì đổi trục: theo một thuộc
     * tính của đơn vị (TBL_ORGANIZATION.IS_BUSINESS đã có sẵn), không theo một id
     * viết cứng.
     */
    static PARTNER_ID = 92;
    static PARTNER_CODE = '*1*' + Account.PARTNER_ID + '*';
    isLogged = false;
    emailSet: AccountEmail[];
    statusSet: AccountStatus[];
    oldPassword: string;
    idToken: string;
    org: Organization;
    leader: Account;
    isRoot = false;
    keyword: string;
    sortBy = 'createdDate';
    ascending = false;
    allChildren = true;
    roleCheck = false;
    // country: Country;
    countryIdList: number[];
    professionChecked: number[];
    employeeTypeChecked: string[];
    workhourChecked: string[];
    workdayChecked: string[];
    endDateRange: string;
}
